import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SEO from '../components/SEO';
import { getNotFoundContent } from '../config/notFoundLinks';
import './NotFound.css';

function LinkBlock({ title, links }) {
  return (
    <div className="not-found-block">
      <h2>{title}</h2>
      <ul className="not-found-links">
        {links.map((link) => (
          <li key={link.href}>
            <Link to={link.href}>{link.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

function NotFound() {
  const { pathname } = useLocation();
  const content = getNotFoundContent(pathname);
  const locale = pathname.startsWith('/en') ? 'en' : 'fr';

  return (
    <>
      <SEO
        locale={locale}
        title={content.title}
        description={content.description}
        noIndex
      />
      <main className="not-found section" id="main-content">
        <div className="container not-found-inner">
          <h1>{content.h1}</h1>
          <p className="not-found-intro">{content.intro}</p>
          <Link to={content.homeHref} className="btn btn-primary not-found-home">
            {content.homeLabel}
          </Link>

          <LinkBlock title={content.sectionsTitle} links={content.sections} />
          <LinkBlock title={content.popularTitle} links={content.popular} />
          <LinkBlock title={content.intentsTitle} links={content.intents} />

          <p className="not-found-locale">
            <Link to={content.otherLocaleHref}>{content.otherLocaleLabel}</Link>
          </p>
        </div>
      </main>
    </>
  );
}

export default NotFound;
